import type { ReentryCard as ReentryCardSchema } from "@acto/genui-components-schema";
import { useTranslations } from "@acto/web-common/locales";
import { Card } from "@acto/taskpane/field-sales-2/components/primitives/Card";
import { Divider } from "@acto/taskpane/field-sales-2/components/primitives/Divider";
import { CardHeader } from "./CardHeader";
import { KpiPair } from "./KpiPair";
import { OrderScopeEntries } from "./OrderScopeEntries";

export function ReentryCard({ part }: { part: ReentryCardSchema }) {
  const t = useTranslations("fieldSalesTwo.genuiMeetingPrep.reentryCard");

  return (
    <Card nested>
      <CardHeader label={part.label} headline={part.product.name} />
      <Divider />
      <KpiPair items={part.kpis} />
      <Divider />
      <OrderScopeEntries
        section={part.orders}
        allOrdersTitle={t("productOrders")}
        productId={part.product.id}
        orderListEyebrow={part.product.name}
      />
    </Card>
  );
}
